import {
  VALID_MEASURE_UNIT_REGEX,
  VALID_SLUG_REGEX,
  validation,
} from '@ipfabric/utils';
import type { FormikErrors } from 'formik';
import Joi from 'joi';
import type { AppTranslations } from 'translations/translations';
import { makeJoiPredicate } from './makeJoiPredicate';

export const cidrSchema = Joi.string()
  .ip({ cidr: 'required', version: ['ipv4'] })
  .required();
export const isValidCidr = makeJoiPredicate(cidrSchema);

export const ipSchema = Joi.string()
  .ip({ cidr: 'forbidden', version: ['ipv4'] })
  .required();
export const isValidIp = makeJoiPredicate(ipSchema);

export const v4AddressSchema = Joi.string()
  .ip({ version: ['ipv4'] })
  .required();
export const isValidIpv4Address = makeJoiPredicate(v4AddressSchema);

export const cidrIpv6Schema = Joi.string()
  .ip({ cidr: 'required', version: ['ipv6'] })
  .required();
export const isValidCidrIpv6 = makeJoiPredicate(cidrIpv6Schema);

export const ipv6Schema = Joi.string()
  .ip({ cidr: 'forbidden', version: ['ipv6'] })
  .required();
export const isValidIpv6 = makeJoiPredicate(ipv6Schema);

export const ipv6AddressSchema = Joi.string()
  .ip({ version: ['ipv6'] })
  .required();
export const isValidIpv6Address = makeJoiPredicate(ipv6AddressSchema);

export const v4or6AddressSchema = Joi.string()
  .ip({ version: ['ipv4', 'ipv6'] })
  .required();
export const isValidIpv4or6Address = makeJoiPredicate(v4or6AddressSchema);

export const portSchema = Joi.number().min(1).max(65535).required();
export const isValidPort = makeJoiPredicate(portSchema);

export const numberSchema = Joi.number().required();
export const isValidNumber = makeJoiPredicate(numberSchema);

export const measureUnitSchema = Joi.string().pattern(VALID_MEASURE_UNIT_REGEX);
export const isValidMeasureUnit = makeJoiPredicate(measureUnitSchema);

export const isValidSlug = makeJoiPredicate(validation.slugSchema);

export function validateSlug(
  values: { slug?: string },
  errors: FormikErrors<{ slug: string }>,
  msg: AppTranslations,
): void {
  const { pattern } = msg.discoverySettings.vendorsApi.validations;

  if (!isValidSlug(values.slug)) {
    errors.slug = pattern.replace('{pattern}', VALID_SLUG_REGEX.toString());
  }
}

const roleNameSchema = validation.slugSchema.required();
export const isValidRoleName = makeJoiPredicate(roleNameSchema);

export function validateRoleName(
  values: { name: string },
  errors: FormikErrors<{ name: string }>,
  msg: { pattern: string; required: string },
): void {
  const { required, pattern } = msg;

  if (!isValidRoleName(values.name)) {
    errors.name = pattern.replace('{pattern}', VALID_SLUG_REGEX.toString());
  }
  if (!values.name) {
    errors.name = required;
  }
}
